import { Routes, Route } from 'react-router-dom'
import ClientDashboard from './ClientDashboard'
import ContentUpload from './ContentUpload'
import Analytics from './Analytics'
import ApiDocs from './ApiDocs'
import Webhooks from './Webhooks'
import Settings from './Settings'
import MediaRecordPage from '../MediaRecordPage'

const ClientPortal: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ClientDashboard />} />
      <Route path="upload" element={<ContentUpload />} />
      <Route path="analytics" element={<Analytics />} />
      <Route path="api" element={<ApiDocs />} />
      <Route path="webhooks" element={<Webhooks />} />
      <Route path="settings" element={<Settings />} />
      <Route path="media/:mediaId" element={<MediaRecordPage />} />
    </Routes>
  )
}

export default ClientPortal 